<template>
    <div
        class="json-cell"
        :class="[field.alignment, { 'invalid-value': invalidValue, outlined: outlined, readonly: readonly }]"
        @mouseenter="showOverlay = true"
        @mouseleave="showOverlay = false"
    >
        <!-- Görüntüleme Modu -->
        <div class="json-chip" :class="{ 'has-json': hasJsonValue }">
            <span v-if="hasJsonValue">{{ $t('table.hasJson') }}</span>
            <span v-else>{{ $t('table.noJson') }}</span>
        </div>

        <!-- Hover Overlay'de Aksiyon İkonları -->
        <div v-if="showOverlay && !readonly" class="overlay-actions">
            <PermissionController :permissions="['table.update']">
                <a-button icon="edit" size="small" @click="openJsonEditor" style="margin-right: 4px"></a-button>
            </PermissionController>
            <PermissionController :permissions="['table.update']">
                <a-button
                    icon="delete"
                    type="danger"
                    size="small"
                    @click="deleteValue"
                    style="margin-right: 4px"
                ></a-button>
            </PermissionController>
        </div>

        <!-- JSON Editör Modal -->
        <Modal2
            v-if="showJsonEditorModal"
            @cancel="closeJsonEditor"
            :title="$t('tables.jsonEditorTitle')"
            :showFooter="true"
            :okText="$t('message.save')"
            :cancelText="$t('message.cancel')"
            @ok="saveJsonValue"
            xlarge
        >
            <div class="json-editor-container">
                <v-jsoneditor
                    v-model="editingValue"
                    :options="jsonEditorOptions"
                    height="400px"
                    @error="onJsonError"
                ></v-jsoneditor>
                <div v-if="jsonError" class="json-error">
                    {{ jsonError }}
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import VJsoneditor from "v-jsoneditor";
import Modal2 from "@/components/common/Modal2.vue";

export default Vue.extend({
    name: "JsonCell",
    components: {
        Modal2,
        VJsoneditor,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showOverlay: false,
            showJsonEditorModal: false,
            editingValue: null,
            jsonError: null,
            invalidValue: false,
            jsonEditorOptions: {
                mode: "tree",
                modes: ["tree", "code"],
                navigationBar: false,
                mainMenuBar: true,
                statusBar: false,
                language: "tr",
            },
        };
    },
    computed: {
        hasJsonValue() {
            const value = this.record.data[this.field._id];
            return value && value !== "";
        },
        formattedValue() {
            try {
                const value = this.record.data[this.field._id];
                return value ? JSON.stringify(value, null, 2) : "";
            } catch (error) {
                return "";
            }
        },
    },
    methods: {
        openJsonEditor() {
            if (this.readonly) return;
            try {
                const value = this.record.data[this.field._id];
                this.editingValue = value || null;
                this.showJsonEditorModal = true;
                this.jsonError = null;
            } catch (error) {
                this.jsonError = `JSON Hatası: ${error.message}`;
            }
        },
        closeJsonEditor() {
            this.showJsonEditorModal = false;
            this.jsonError = null;
        },
        deleteValue() {
            this.$emit("update-record", {
                recordId: this.record._id,
                fieldId: this.field._id,
                value: null,
            });
        },
        saveJsonValue() {
            if (!this.jsonError) {
                this.invalidValue = false;
                this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: this.editingValue,
                });
                this.showJsonEditorModal = false;
            }
        },
        onJsonError(error) {
            this.jsonError = `JSON Hatası: ${error.toString()}`;
            this.invalidValue = true;
        },
        onJsonChange(value) {
            console.log("onJsonChange", value);
            this.editingValue = value;
        },
        isValidJson(value) {
            return typeof value === "object";
        },
    },
    watch: {
        editingValue: {
            handler(value) {
                const isValidJson = this.isValidJson(value);
                console.log("isValidJson", isValidJson);
                if (!isValidJson) {
                    this.invalidValue = true;
                } else {
                    this.invalidValue = false;
                    this.jsonError = null;
                }
            },
        },
    },
});
</script>

<style lang="scss" scoped>
.json-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    transition: all 0.3s;
    position: relative;

    .json-chip {
        padding: 4px 12px;
        border-radius: 16px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        background-color: #f5f5f5;

        &.has-json {
            background-color: #e6f7ff;
            color: #1890ff;
        }
    }

    .overlay-actions {
        position: absolute;
        top: 2px;
        right: 2px;
        display: flex;
        gap: 4px;
    }

    &.outlined {
        border: 1px solid #d9d9d9;
        border-radius: 4px;

        &:not(.readonly) {
            cursor: pointer;

            &:hover {
                border-color: #40a9ff;
            }
        }

        &.readonly {
            background-color: #f5f5f5;
            border-color: #d9d9d9;
            cursor: not-allowed;
        }
    }

    &.invalid-value {
        background-color: #fff1f0;
    }
}
</style>
<style lang="scss">
.json-editor-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 68vh;

    .json-error {
        color: #ff4d4f;
        padding: 8px;
        background-color: #fff1f0;
        border: 1px solid #ffccc7;
        border-radius: 4px;
    }

    .jsoneditor-container {
        min-height: 68vh;
    }
}
</style>
